import { render, staticRenderFns } from "./typeForm.vue?vue&type=template&id=4a3c7043&scoped=true"
import script from "./typeForm.vue?vue&type=script&lang=js"
export * from "./typeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c7043",
  null
  
)

export default component.exports